import React, { useEffect, useContext, useState } from 'react'
import {
  Container
} from 'reactstrap'
import { withNamespaces } from 'react-i18next'
import { isEmpty } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ApiService from '../../data/services/ApiService'
import Store from './components/Store'
import { GeneralContext } from '../../context/'

const StoreCreate = () => {
  const generalContext = useContext(GeneralContext)
  const { loading, setLoading } = generalContext

  const [store, setStore] = useState({})
  const [domain, setDomain] = useState('')

  async function fetchStore() {
    setLoading(true)
    const response = await ApiService.getStoreByUser()
    setStore(response.data.data)
    setDomain(response.data.domain)
    setLoading(false)
  }

  useEffect(() => {
    (async () => {
      await fetchStore()
    })()
  }, []) // eslint-disable-line

  const updateConfigStore = async (e, storeName, storeUrl, profit) => {
    e.preventDefault()
    setLoading(true)
    const data = {
      id: store.id,
      name: storeName,
      url: storeUrl,
      profit,
    }
    try {
      const response = await ApiService.updateStore(data)
      if (response.data.success) {
        toastr.success(`Tienda actualizada.`, '¡Éxito!')
        await fetchStore()
      }
    } catch(e) {
      toastr.error(`${e.response.data.message}`, 'Error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Mi tienda"
            breadcrumbItem={!isEmpty(store) ? store.name : 'Mi tienda'}
            parentLink={`/mi-tienda`}
          />
          <Store
            loading={loading}
            store={store}
            domain={domain}
            updateConfigStore={updateConfigStore}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withNamespaces()(StoreCreate)

